module.exports = __webpack_public_path__ + "static/media/Swashakthi-SHG-testimonial-1.4c40a184.webp";